<div class="d-flex flex-column gap-3 p-3">
	@for (row of citiesGrid(); let i = $index; track i) {
		<div class="d-flex flex-row gap-3">
			@for (city of row; let j = $index; track j) {
				<div class="col gap-3 city-container">
					<app-city [city]="city" [vehicleInUse]="vehicleInUse()"></app-city>
				</div>
			}
		</div>
	}
</div>
